export default function Icon({ name, className = '', filled = false, style, ...props }) {
  return (
    <span
      className={`material-symbols-outlined${filled ? ' filled' : ''} ${className}`}
      style={style}
      aria-hidden="true"
      {...props}
    >
      {name}
    </span>
  )
}
